import React from "react";
import { CDBTable, CDBTableBody, CDBTableHeader } from "cdbreact";
import moment from "moment";

const RenderEstado = ({ status }) => {
  if (!status) return null;
  const isActive = status.toLowerCase() === "active";
  const iconClass = isActive ? "fa-check-circle" : "fa-times-circle";
  const backgroundColor = isActive ? "#0E9600" : "#FF4444";
  const text = isActive ? "Activo" : "Inactivo";
  return (
    <span
      style={{
        display: "inline-block",
        padding: "5px 10px",
        color: "white",
        backgroundColor,
        borderRadius: "8px",
        fontSize: "12px",
        fontWeight: "bold",
        textAlign: "center",
      }}
    >
      <i className={`fa ${iconClass}`} style={{ marginRight: "5px" }}></i>
      {text}
    </span>
  );
};

export const SmartLinksListTable = ({ items, selectedColumns, allColumns }) => {
  return (
    <CDBTable
      hover
      responsive
      maxHeight="70vh"
      scrollY
      className="responsive-table"
      style={{
        fontSize: "15px",
        fontFamily: "Montserrat, sans-serif",
        overflowX: "auto",
        whiteSpace: "nowrap",
        marginTop: "100px",
      }}
    >
      <CDBTableHeader>
        <tr
          style={{
            textAlign: "center",
            backgroundColor: "#3E4144",
            color: "white",
          }}
        > 
          {allColumns.map(
            (column) =>
              (column.alwaysShow || selectedColumns.includes(column.key)) && (
                <th
                  key={column.key}
                  style={{
                    borderTop: "1px solid #DCDCDC",
                    borderBottom: "1px solid #DCDCDC",
                    backgroundColor: "#DCDCDC",
                    color: "#3E4144",
                  }}
                >
                  {column.label}
                </th>
              )
          )}
        </tr>
      </CDBTableHeader>
      <CDBTableBody>
        {items.length > 0 ? (
          items.map((row, idx) => (
            <tr key={`${row.id}-${idx}`} style={{ textAlign: "center" }}>
              {allColumns.map((column) => {
                if (column.alwaysShow || selectedColumns.includes(column.key)) {
                  let content = row[column.property] || "N/A";
                  
                  
                  if (column.key === "Fecha") {
                    content = row.launch_time
                      ? moment(row.launch_time).format("YYYY/MM/DD hh:mm")
                      : "Fecha no disponible";
                  }
                  
                  
                  if (column.key === "Estado") {
                    content = <RenderEstado status={row.status} />;
                  }
                  if (column.key === "Precio") {
  content =
    row[column.property] !== "N/A"
      ? `$${row[column.property]}`
      : "N/A";
}

                  
                if (column.key === "Link") {
                content =
                  row[column.property] !== "N/A" ? (
                    <a
                      href={row[column.property]}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => {
                        // Copiar al portapapeles
                        navigator.clipboard.writeText(row[column.property])
                          .catch(() => {
                            // fallback silencioso (por si falla en http o navegador viejo)
                            const tempInput = document.createElement("input");
                            tempInput.value = row[column.property];
                            document.body.appendChild(tempInput);
                            tempInput.select();
                            document.execCommand("copy");
                            document.body.removeChild(tempInput);
                          });
                      }}
                      style={{
                        color: "#007BFF",
                        textDecoration: "underline",
                        fontWeight: "500"
                      }}
                    >
                      {row[column.property]}
                    </a>
                  ) : (
                    "N/A"
                  );
              }
                  return (
                    <td key={column.key} data-label={column.label}>
                      {content}
                    </td>
                  );
                }
                return null;
              })}
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={allColumns.length}
              style={{
                textAlign: "center",
                padding: "20px",
                color: "#999",
                boxSizing: "border-box",
              }}
            >
              No hay links disponibles
            </td>
          </tr>
        )}
      </CDBTableBody>
    </CDBTable>
  );
};